goog.provide("shadow.js.shim.module$src$svg$objects$target_svg$default");
shadow.js.shim.module$src$svg$objects$target_svg$default = shadow.js.shim.module$src$svg$objects$target_svg.default;
